import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError, retryWhen, mergeMap, delay} from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { ToasterService } from '../modules/shared/common-services/toaster.service';
export const maxRetries = 2;
export const delayMs = 2000;

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, private toasterService : ToasterService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            retryWhen((error) => {
                return error.pipe(
                    mergeMap((error, index) => {
                     //console.log("error---",error)
                     //console.log("index---",index)
                     //console.log("error.status---",error.status)
                        if (error.url.includes('/auth/login')) {
                        }
                        else if (index < maxRetries && (error.status)) {
                            var message = "There was an error processing your request. The application is attempting once more.";
                            this.toasterService.showError(message);
                            return of(error).pipe(delay(delayMs));
                        }else{
                            var message = "There was an error processing your request. Please try again later";
                            this.toasterService.showError(message);
                        }                   

                        throw error;
                    })
                )
            })
        )
       // console.log("HttpInterceptor----------",request)
       // this.toasterService.showError("request");
        // return next.handle(request).pipe(catchError(err => {
        //     console.log("Error--",err)
        //     if (err.url.includes('/auth/login')) 
        //     {  
        //        // console.log("Error-/auth/login-yyyyyyyyyyyy")
        //     }
        //     else{
        //         var message = "There was an error processing your request. Please try again later";
        //         this.toasterService.showError(message);
        //     }
        //     // if (err.status === 401) {
        //     //     // auto logout if 401 response returned from api
        //     //    // this.authenticationService.logout();
        //     //    // location.reload();
        //     //    //this.toasterService.showError(err.error.message);
        //     // }
           
        //     const error = err.error.message || err.message || err.statusText;
           
        //     return throwError(error);
        // }))
    }
}